import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck
} from "@fortawesome/free-solid-svg-icons";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


export function ScoreContainer(props) {
  const { resultObj } = props;
  const { mirs_discipline } = useUrlFriendlyToParameters()
  const winner = resultObj?.wlt === 'W' && <div className='score-winner'><FontAwesomeIcon className='' icon={faCheck} /></div>
  const result = resultObj?.result;

  let scoreSet1;
  let scoreSet2;
  let scoreSet3;
  if (resultObj?.extra?.resultS1) {
    if (resultObj?.extra?.resultS1.indexOf('(') === -1 && resultObj?.extra?.resultS1.length > 0) {
      scoreSet1 = <span className={`${resultObj?.extra?.winS1}`} > {resultObj?.extra?.resultS1}</span >;
    } else if (resultObj?.extra?.resultS1.indexOf('(') !== -1) {
      scoreSet1 = <>
        <span className={resultObj?.extra?.winS1}>
          {resultObj?.extra?.resultS1.substring(0, resultObj?.extra?.resultS1.indexOf('('))}
          <sup>
            {resultObj?.extra?.resultS1.substring(resultObj?.extra?.resultS1.indexOf('('), resultObj?.extra?.resultS1.indexOf(')') + 1)}
          </sup>
        </span>
      </>
    }
  }
  if (resultObj?.extra?.resultS2) {
    if (resultObj?.extra?.resultS2.indexOf('(') === -1 && resultObj?.extra?.resultS2.length > 0) {
      scoreSet2 = <span className={`${resultObj?.extra?.winS2}`} > {resultObj?.extra?.resultS2}</span >;
    } else if (resultObj?.extra?.resultS2.indexOf('(') !== -1) {
      scoreSet2 = <>
        <span className={resultObj?.extra?.winS2}>
          {resultObj?.extra?.resultS2.substring(0, resultObj?.extra?.resultS2.indexOf('('))}
          <sup>
            {resultObj?.extra?.resultS2.substring(resultObj?.extra?.resultS2.indexOf('('), resultObj?.extra?.resultS2.indexOf(')') + 1)}
          </sup>
        </span>
      </>
    }
  }
  if (resultObj?.extra?.resultS3) {
    if (resultObj?.extra?.resultS3.indexOf('(') === -1 && resultObj?.extra?.resultS3.length > 0) {
      scoreSet3 = <span className={`${resultObj?.extra?.winS3}`} > {resultObj?.extra?.resultS3}</span >;
    } else if (resultObj?.extra?.resultS3.indexOf('(') !== -1) {
      scoreSet3 = <>
        <span className={resultObj?.extra?.winS3}>
          {resultObj?.extra?.resultS3.substring(0, resultObj?.extra?.resultS3.indexOf('('))}
          <sup>
            {resultObj?.extra?.resultS3.substring(resultObj?.extra?.resultS3.indexOf('('), resultObj?.extra?.resultS3.indexOf(')') + 1)}
          </sup>
        </span>
      </>
    }
  }

  return (
    <div className='score-result-container d-flex flex-row justify-content-end align-self-center'>
      <div className="align-self-center row w-100 m-0">
        <div className='col-2 p-0 small'>
          {winner}
        </div>
        {resultObj?.extra?.resultS1 && <div className="score-result p-0 col">{scoreSet1}</div>}
        {resultObj?.extra?.resultS2 && <div className="score-result p-0 col">{scoreSet2}</div>}
        {resultObj?.extra?.resultS3 && <div className="score-result p-0 col">{scoreSet3}</div>}
        {resultObj?.hasIRM === true
          ? <div className="col p-0 fw-bold">
            <SportCode discipline={mirs_discipline} code={resultObj?.irm} entity="@IRM" abbr={true} />
          </div>
          : ''
        }
      </div>
    </div>
  )
}
